import styled from "@emotion/styled";
const Status = {
    Wrapper: styled.div `
    margin: 0 4em 1em 4em;
    font-size: 0.6rem;
    height: 1em;
    display: flex;
    visibility: ${({ hidden }) => hidden ? "hidden" : "visible"};
  `,
};
export default Status;
//# sourceMappingURL=Status.styled.js.map